import {
  SIGN_IN_SUCCESS,
  CORPORATE_ID,
  CORPORATE_DATA,
  SET_USER_ROLE,
  SET_USER_ID,
  SET_USER_INFO,
  SET_COUNTRIES_LIST,
  SET_STATES_LIST,
  SET_CITIES_LIST,
  SET_DASHBOARD_DATA,
  SET_DASHBOARD_NAVS,
  SET_NOTIFICATION_LIST,
  SET_USER_PERMISSIONS
} from 'modules/Auth/actions'

const initialState = {
  token: null,
  corporateId: '',
  corporateData: {},
  userRoleList: [],
  userId: '',
  userData: {},
  listOfCountries: [],
  listOfStates: [],
  listOfCities: [],
  dashboardData: {},
  dashboardNavs: null,
  notificationData: {},
  permissions: []
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SIGN_IN_SUCCESS:
      return {
        ...state,
        token: action.token,
      }
    case CORPORATE_ID:
      return {
        ...state,
        corporateId: action.id,
      }
    case CORPORATE_DATA:
      return {
        ...state,
        corporateData: action.data,
      }
    case SET_USER_ROLE:
      return {
        ...state,
        userRoleList: action.list,
      }
    case SET_USER_ID:
      return {
        ...state,
        userId: action.id,
      }
    case SET_USER_INFO:
      return {
        ...state,
        userData: action.data,
      }
    case SET_COUNTRIES_LIST:
      return {
        ...state,
        listOfCountries: action.data,
      }
    case SET_STATES_LIST:
      return {
        ...state,
        listOfStates: action.data,
      }
    case SET_CITIES_LIST:
      return {
        ...state,
        listOfCities: action.data,
      }

    case SET_DASHBOARD_DATA:
      return {
        ...state,
        dashboardData: action.data,
      }

    case SET_DASHBOARD_NAVS:
      return {
        ...state,
        dashboardNavs: action.data,
      }
    case SET_NOTIFICATION_LIST:
      return {
        ...state,
        notificationData: action.data,
      }
    case SET_USER_PERMISSIONS:
      return {
        ...state,
        permissions: action.data,
      }
    default:
      return state
  }
}
